import React, { Component } from "react";
import {
    Paper,
    Typography,
    Table,
    TableCell,
    TableRow,
    TableHead,
    TableBody,
    IconButton,
    TablePagination,
    Snackbar,
    SnackbarContent
} from "@material-ui/core";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import styled from "styled-components";

import "./submittedReportsStyles.css";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
const StyledTableCell = styled(TableCell)`
    && {
        width: ${props => props.width}px;
        padding: 4px 10px 4px 24px;
    }
`;
export default class TableData extends Component {
    constructor(props) {
        super(props);
        this.state = { reportNotPresent: false };
    }
    render() {
        const {
            tableData,
            rowsPerPage,
            page,
            setRowsPerPage,
            setPage,
            selectedRow,
            setSelectedRow,
            setModal
        } = this.props;
        return (
            <Table style={{tableLayout: "fixed"}}>
                <Paper style={{border:"0px"}} className="paper">
                    <TableHead>
                    <TableRow>
                            <TablePagination
                                colSpan={13}
                                ActionsComponent={TablePaginationHelper}
                                count={
                                    tableData === false ? 0 : tableData.length
                                }
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={(event, page) => setPage(page)}
                                onChangeRowsPerPage={event =>
                                    setRowsPerPage(event.target.value)
                                }
                                rowsPerPageOptions={[50, 100]}
                            />
                        </TableRow>
                        <TableRow>
                            <TableHeader text="Count" />
                            <TableHeader text="Lighting" />
                            <TableHeader text="Max Site Distance" />
                            <TableHeader text="Traffic Count" />
                            <TableHeader text="Unobstructed Width" />
                            <TableHeader text="Visibility" />
                            <TableHeader text="Road Width" />
                            <TableHeader text="Road Type" />
                            <TableHeader text="Road Layout" />
                            <TableHeader text="Speed" />
                            <TableHeader text="Time" />
                            <TableHeader text="Road Part" />
                            <TableHeader text="Actions"/>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData &&
                            tableData
                            .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                            )
                            .map((e, i) => {
                                return (
                                    <TableRow
                                        style={{
                                            opacity:
                                                e.report_uneditable === true
                                                    ? 0.6
                                                    : 1
                                        }}
                                        selected={
                                            selectedRow === i ? true : false
                                        }
                                        onClick={() => {
                                            setSelectedRow(i);
                                        }}
                                        key={i}
                                    >
                                        <InfoCell
                                            text={e.count ? e.count : 0}
                                        />
                                        <InfoCell text={e.plan.lighting} />
                                        <InfoCell text={e.plan.maxSiteLength} />
                                        <InfoCell text={e.plan.maxTrafficCount} />
                                        <InfoCell text={e.plan.minUnobstructedWidth} />
                                        <InfoCell text={e.plan.minVisibility} />
                                        <InfoCell text={e.plan.roadwayWidth} />
                                        <InfoCell text={e.plan.roadType} />
                                        <InfoCell text={e.plan.roadLayout} />
                                        <InfoCell text={e.plan.speed} />
                                        <InfoCell text={e.plan.time} />

                                        <InfoCell style={{wordWrap:"break-word"}} text={e.plan.roadPart} />

                                        <TableCell>
                                            <IconButton
                                                onClick={() => {
                                                    setModal(true, "view", i);
                                                }}
                                                id="viewIcon"
                                            >
                                                <ViewIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    <Snackbar
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left"
                        }}
                        autoHideDuration={4000}
                        open={this.state.reportNotPresent}
                        onClose={() => {
                            this.setState({ reportNotPresent: false });
                        }}
                    >
                        <SnackbarContent
                            style={{
                                backgroundColor: "red",
                                color: "white"
                            }}
                            message="Unable to Find Report, Please Contact System Admin With Report Details"
                        />
                    </Snackbar>
                </Paper>
            </Table>

        );
    }
}
const TableHeader = props => {
    return (
        <StyledTableCell>
            <Typography variant="body2">
                <b>{props.text}</b>
            </Typography>
        </StyledTableCell>
    );
};

const InfoCell = props => {
    return (
        <StyledTableCell>
            <Typography variant="body2">{props.text}</Typography>
        </StyledTableCell>
    );
};
